/**
 * The "My Results" menu — a member's own scores and progress. See
 * lib/navigation/nav-manifest.js for the entry shape and the vocabulary
 * `requires` draws from.
 */

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const RESULTS_ITEMS = [
  {
    href: "/dashboard",
    label: "Overview",
    heading: "My Results",
    description: "Track your results and assignments",
    shortcut: "M",
    iconName: "IoHomeOutline",
    requires: "workspace",
  },
  {
    href: "/leaderboard",
    label: "Leaderboard",
    heading: "Leaderboard of Top Results",
    description: "Track your performance and compare with others",
    iconName: "CiTrophy",
    requires: "workspace",
  },
  {
    label: "Practice",
    iconName: "LiaTheaterMasksSolid",
    requires: "workspace",
    subItems: [
      {
        href: "/dashboard/discovery",
        label: "Discovery",
        iconName: "CiMap",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/pitch",
        label: "Messaging / Pitch",
        iconName: "HiOutlinePresentationChartBar",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/objections",
        label: "Objections",
        iconName: "HiNoSymbol",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/cold-call",
        label: "Outbound & Inbound",
        iconName: "IoCallOutline",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/plays",
        label: "Plays",
        iconName: "LiaTheaterMasksSolid",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/plays/on-the-fly",
        label: "On-the-fly Plays",
        iconName: "LiaTheaterMasksSolid",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/management",
        label: "Management Practice",
        iconName: "HiOutlineUserGroup",
        requires: "dashboardModule",
      },
      // Persona Chats is not listed here (taken off on 2 November 2026); it
      // is in OFF_MENU_PAGES, so search still finds it.
    ],
  },
  // Practice scores only. Deal readouts and analyzed conversations are real
  // deals and calls, and their lists are where Execution opens, so they are
  // not repeated here (Michael, 20 October). Assignments, tests and learning
  // paths are listed where you do them (Practice and Learn), not again here.
  {
    label: "Coaching",
    iconName: "IoStatsChartOutline",
    requires: "workspace",
    subItems: [
      {
        href: "/dashboard/feedback-analysis",
        label: "Coaching Report",
        heading: "Coaching report",
        description:
          "AI-powered insights from your practice simulations and real conversations.",
        iconName: "IoStatsChartOutline",
      },
      {
        href: "/dashboard/feedback-comments",
        label: "Feedback Comments",
        heading: "Feedback",
        description: "Review feedback left on your practice sessions.",
        iconName: "IoChatbubbleOutline",
      },
    ],
  },
  {
    label: "Goals",
    iconName: "Target",
    requires: "workspace",
    subItems: [
      {
        href: "/dashboard/okrs",
        label: "OKRs",
        description: "Set objectives and track your key results.",
        iconName: "Target",
        requires: "dashboardModule",
      },
      {
        href: "/dashboard/badges",
        label: "Badges",
        description: "Track the badges you've earned across your practice.",
        iconName: "IoRibbonOutline",
        requires: "dashboardModule",
      },
    ],
  },
];
